import React, { useState } from 'react';
import { cnCreateForm } from '../FormModule';
import { Textinput } from '@yandex/ui/Textinput/desktop/bundle';
import { Button } from '../../../../components/Button';

interface AddOptionsProps {
    options: Record<string, string>;
    setOptions: (object: Record<string, string>) => void;
}

function AddOptions({options, setOptions} 
    : AddOptionsProps) {
    
    const [modal, setModal] = useState(false);
    const [error, setError] = useState('');
    const [name, setName] = useState('');

    const onFocus = () => {
        setError('');
    }

    const handleSubmit =  () => {
        if( name.length === 0) {
            setError("Необходимо заполнить все поля");
            return;
        } else if (name.length < 6) {
            setError("Наименование должно содержать более 5 символов");
            return;
        } else if (options.hasOwnProperty(name)) {
            setError("Значение уже существует");
            return;
        }else {
            setOptions(  {...options, [name]: name});
             openCloseModal();
         }
    }

    const openCloseModal = () => {
        setModal(!modal);
    }

  return (
    <>
    { modal ?
        <div className={cnCreateForm('Modal-Content')}>
                <div>
                    <label htmlFor="name">Наименование (русскими буквами, чтобы было понятно)</label>
                    <Textinput
                        className={cnCreateForm('Textinput')}
                        value={name}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
                        onFocus={onFocus}
                        name="name"
                    />
                </div>

                { error && <div className='text-danger'> {error}</div>}

       
            <div className={cnCreateForm('Box-Input')}>
                <Button
                    className={cnCreateForm('Button')}
                    type={'button'}
                    text={`Добавить`}
                    leftIcon={ {path: 'plus2', width: 16, height: 16, marginRight: 8} }
                    mods={{
                        mods: {bkg: 'white', color: 'lightGreen', border: 'lightGreen', fill: 'lightGreen'},
                        hover: {mods: {bkg: 'lightGreen', color: 'white', fill: 'white'}}
                    }}
                    callBack={handleSubmit}
                />

                <Button
                    className={cnCreateForm('Button')}
                    type={'button'}
                    text={`Закрыть`}
                    mods={{
                        mods: {bkg: 'white', color: 'lightRed', border: 'red', fill: 'lightRed'},
                        hover: {mods: {bkg: 'lightRed', color: 'white', fill: ''}}
                    }}
                    callBack={openCloseModal}
                />
            </div>
        </div>
    :
    <Button
        className={cnCreateForm('Button')}
        type={'button'}
        text={`Добавить свои значения в список`}
        leftIcon={ {path: 'plus2', width: 16, height: 16, marginRight: 8} }
        mods={{
            mods: {bkg: 'white', color: 'lightGreen', border: 'lightGreen', fill: 'lightGreen'},
            hover: {mods: {bkg: 'lightGreen', color: 'white', fill: 'white'}}
        }}
        callBack={openCloseModal}
    />
    }
    </>
  )
}

export default AddOptions
